import React, { memo, useEffect, useState } from 'react';
import {
    Line,
    LineChart as StyledLineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis
} from 'recharts';
import styled from 'styled-components';
import { ChartDataType } from '@utils/types';
import theme from '@styles/theme';

type LineChartProps = {
    title?: string;
    subTitle?: string;
    data?: ChartDataType[];
};

const LineChart = ({ title, subTitle, data = [] }: LineChartProps) => {
    const [chartData, setChartData] = useState<ChartDataType[]>([]);

    useEffect(() => {
        if (data?.length > 0) {
            setChartData(data);
        }
    }, [data]);

    return (
        <Wrapper>
            <Title>{title}</Title>
            <SubTitle>{subTitle || ''}</SubTitle>
            <ChartBox>
                <ResponsiveContainer>
                    <StyledLineChart data={chartData}>
                        <Line
                            type="linear"
                            dot={false}
                            dataKey="value"
                            stroke="#0B4177"
                            strokeWidth={2}
                        />
                        <XAxis
                            className="xAxis"
                            dataKey="name"
                            tickMargin={6}
                            tickLine={false}
                            padding={{ left: 8, right: 8 }}
                            axisLine={{
                                stroke: theme.colors.ultraLightGrayBorder,
                                strokeWidth: 1
                            }}
                        />
                        <Tooltip
                            formatter={(value) => [
                                `${value?.toLocaleString()}명`
                            ]}
                        />
                    </StyledLineChart>
                </ResponsiveContainer>
            </ChartBox>
        </Wrapper>
    );
};

export default memo(LineChart);

const Wrapper = styled.div`
    width: 100%;
    height: 274px;
    /* margin: 30px 0 60px; */
`;
const Title = styled.div`
    ${theme.typography.caption};
    font-family: PretendardSemiBold, sans-serif;
`;
const SubTitle = styled.div`
    ${theme.typography.caption};
    color: ${theme.colors.deepGrayFontColor};
    margin: 8px 0 20px;
`;
const ChartBox = styled.div`
    width: calc(100% + 24px);
    height: 215px;
    transform: translateX(-12px);

    .recharts-cartesian-axis-ticks {
        text {
            font-size: 14px;
            fill: ${theme.colors.deepGrayFontColor};
        }

        .recharts-cartesian-axis-tick:first-child {
            text {
                transform: translateX(8px);
            }
        }

        .recharts-cartesian-axis-tick:last-child {
            text {
                transform: translateX(-10px);
            }
        }
    }
`;
